import { useQuery } from 'react-query';

import finesService from '../../services/api/fines/fines.api.service';

export const useBusinessEntities = () => {
  return useQuery('businessEntities', finesService.fetchBusinessFilterData);
};
